export const componentDurationMap = new Map([
  [91, 30], // 12,5 ist hinterlegt
  [89, 50], // 17,5 ist hinterlegt -
  [198, ''],
]);
